import { C } from '@ridgewill/brand';
import { supportToken } from '../lib/fleet-token.js';
import { usePersonName } from '../lib/people.js';
import { reportsApi } from '../lib/reports-api.js';

/** One client for Support > Reports, on the support session's token (support#87). */
export const api = reportsApi(supportToken);

/** A person's name from auth at render time, never stored with the report. */
export function PersonName({ id }: { id: string | null }) {
  const name = usePersonName(id);
  if (!id) return <span style={{ color: C.textMid2 }}>Nobody named</span>;
  return <>{name ?? id}</>;
}
